<template>
  <v-container>
    <page-heading>{{ pageTitle }}</page-heading>

    <v-tabs v-model="currentTab">
      <v-tab>{{ trans('misc.miscsObject') }}</v-tab>
      <v-tab>{{ trans('misc.miscsObjectRecurring') }}</v-tab>
    </v-tabs>

    <v-tabs-items v-model="currentTab">
      <v-tab-item>
        <objects-miscs />
      </v-tab-item>
      <v-tab-item>
        <recurring-miscs />
      </v-tab-item>
    </v-tabs-items>

  </v-container>
</template>

<script>
import ObjectsMiscs from '../components/ObjectMiscs';
import RecurringMiscs from '../components/RecurringMiscs';
import PageHeading from '../components/PageHeading';
import {LocaleUtils} from '../utils/locale-utils';

export default {
  name: 'ObjectsMiscsPage',
  mixins: [
    LocaleUtils
  ],
  components: {
    PageHeading,
    RecurringMiscs,
    ObjectsMiscs
  },
  data: () => ({
    currentTab: 0
  }),
  computed: {
    pageTitle () {
      return this.trans('misc.miscsObject');
    }
  },
  activated () {
    // this.$refs.objectMiscsTable.loadData();
  }
}
</script>

<style>
</style>
